export default [
  {
    title: 'Users Management',
    icon: 'UserIcon',
    children: [
      {
        title: 'User List',
        route: 'users-user-list',
      },
      {
        title: 'Add User',
        route: 'users-user-add',
      },
	  {
	    title: 'Edit User',
	    route: { name: 'users-user-edit', params: { name: 1 } },
		hidden: true,
	  },
    ],
  },
  {
    title: 'Group Management',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Group List',
        route: 'users-group-list',
      },
      {
        title: 'Add Group',
        route: 'users-group-add',
      },
	  {
	    title: 'Edit Group',
	    route: { name: 'users-group-edit', params: { name: 1 } },
		hidden: true,
	  },
    ],
  }
]
